import axios from 'axios'
import { stripCep, CEP_DIGIT_LENGTH } from '@/utils/cep'
import type { CepLookupData, ViaCepResponse } from '@/types/CepType'

const viaCepHttp = axios.create({
  baseURL: 'https://viacep.com.br/ws',
  timeout: 5000,
})

export function normalizeCep(raw: string): string {
  return stripCep(raw)
}

function toCepLookupData(data: ViaCepResponse, cep: string): CepLookupData {
  return {
    cep,
    street: data.logradouro ?? '',
    neighborhood: data.bairro ?? '',
    city: data.localidade ?? '',
    state: data.uf ?? '',
    complement: data.complemento || null,
  }
}

export async function lookupAddressByCep(raw: string): Promise<CepLookupData | null> {
  const cep = normalizeCep(raw)

  if (cep.length !== CEP_DIGIT_LENGTH) {
    return null
  }

  const { data } = await viaCepHttp.get<ViaCepResponse>(`/${cep}/json/`)

  if (data.erro) {
    return null
  }

  return toCepLookupData(data, cep)
}